module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"assess":"Assess"},"es":{"assess":"Evaluar"},"sw":{"assess":"Tathmini"}}')
  delete Component.options._Ctor
}
